import R from 'app/assets/R'
import { BaseForm } from 'app/components/common/forms/BaseForm'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { IFormDegreeModalData, IFormDegreeModalRule } from './type'
import { StatusDegreeType } from '.'
import { isEqual } from 'lodash'
import { IIndustry } from 'app/api/degree/model/management'
import { ResponseType } from 'parkway-web-common'
import { requestGetAllIndustryManagement } from 'app/api/industry'
import { IndustryMessageCode } from 'app/api/industry/constant'
import { IDegreeClassification } from 'app/api/degreeclassification/model/management'
import { requestGetAllDegreeClassificationManagement } from 'app/api/degreeclassification'
import { DegreeClassificationMessageCode } from 'app/api/degreeclassification/constant'

interface IPropsUseModalHook {
  handleSubmit: (values) => boolean
}

export const useModalHook = ({ handleSubmit }: IPropsUseModalHook) => {
  const { t } = useTranslation()
  const [form] = BaseForm.useForm()
  const [visible, setVisible] = useState(false)
  const [status, setStatus] = useState<StatusDegreeType | undefined>()
  const [industries, setIndustry] = useState<IIndustry[]>()
  const [degreeClassifications, setDegreeClassifications] =
    useState<IDegreeClassification[]>()

  const showModal = () => {
    setVisible(true)
  }

  const handleCancel = () => {
    setVisible(false)
    form.resetFields()
  }

  const onFinish = async (values: IFormDegreeModalData[]) => {
    handleSubmit(values)

    form.resetFields()
    setVisible(false)
  }

  const getAllIndustry = async () => {
    try {
      const res: ResponseType<IIndustry[]> =
        await requestGetAllIndustryManagement()

      if (
        isEqual(
          res?.msgcode,
          IndustryMessageCode.IndustryManagement.successGetData,
        )
      ) {
        const data: IIndustry[] = res?.data || []
        setIndustry(data)
      }
    } catch (error) {
     // console.log({ error })
    }
  }

  const getAllDegreeClassification = async () => {
    try {
      const res: ResponseType<IDegreeClassification[]> =
        await requestGetAllDegreeClassificationManagement()

      if (
        isEqual(
          res?.msgcode,
          DegreeClassificationMessageCode.DegreeClassificationManagement
            .successGetData,
        )
      ) {
        const data: IDegreeClassification[] = res?.data || []
        setDegreeClassifications(data)
      }
    } catch (error) {
     // console.log({ error })
    }
  }

  useEffect(() => {
    visible && getAllIndustry()
    visible && getAllDegreeClassification()
  }, [visible])

  const rules: IFormDegreeModalRule = useMemo(() => {
    return {
      name: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.degree_field_name),
          }),
        },
      ],
      degree: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.degree_field_degree),
          }),
        },
      ],
      degree_classification: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.degree_field_degree_classification),
          }),
        },
      ],
      start: [
        {
          required: true,
          message: t(R.strings.choose_date),
        },
      ],
      end: [],
      document: [
        {
          required: true,
          message: t(R.strings.require_field, {
            field: t(R.strings.document),
          }),
        },
      ],
    }
  }, [t])

  return {
    form,
    visible,
    t,
    showModal,
    onFinish,
    handleCancel,
    rules,
    setStatus,
    status,
    industries,
    degreeClassifications,
  }
}
